import {BaseService} from './baseService.js';
import {Service} from './service.js';

/* 
 * Handles interaction with the Company type Configs
 */
export class CompanyTypeConfigService extends BaseService {
	
	constructor() {	
		super();
	}
	
	async getConfigs() {
		var data = await this.makeGETRequest('/api/resource/company-type-configs');		
		return data;
	}	
	
	async getConfig(companyType) {
		var data = await this.makeGETRequest('/api/resource/company-type-configs/' + companyType);		
		return data;
	}
	
	async getAvailableTemplates() {
		var data = await this.makeGETRequest('/api/resource/company-type-configs/template-types');		
		return data;
	}
	
	async saveConfig(config, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/company-type-configs/' + config.companyType, config);
		} else {
			saved = await this.makePOSTRequest('/api/resource/company-type-configs', config);
		}
		return saved;
	}
	
	async deleteConfig(companyType) {		
		var result = await this.makeDELETERequest('/api/resource/company-type-configs/' + companyType);		
		return result;
	}
	
};
